//* Seller(꽃집) 정산 내역 페이지 전용 hook (미정산 + 정산완료)

import { fetcher, queryString, useRecoilQuery } from '@shared/hooks/recoil-query';
import { useAuth } from '@shared/state/hooks/useAuth';

import { AccountDetailType } from './needAccount.interface';
import {
  sellerMonthlyAccountedDataAtom,
  sellerMonthlyAccountedStatusAtom,
  sellerNeedAccountDataAtom,
  sellerNeedAccountStatusAtom,
} from './sellerAccount.atom';

// ── 미정산 내역 (need-account) ──

export const sellerNeedAccountUrl = (sellerRole: string, userId?: string) => {
  return `/${sellerRole}/shop-order/account/need-account?${queryString({
    ...(userId && { userId }),
  })}`;
};

export const useSellerNeedAccountHook = (userId?: string) => {
  const { sellerRole } = useAuth();

  useRecoilQuery(
    sellerNeedAccountStatusAtom,
    sellerNeedAccountDataAtom,
    sellerNeedAccountUrl(sellerRole(), userId),
    fetcher,
  );
};

// ── 정산완료 내역 (monthly-accounted) ──

export const sellerMonthlyAccountedUrl = (
  sellerRole: string,
  year?: number,
  userId?: string,
) => {
  return `/${sellerRole}/shop-order/account/monthly-accounted?${queryString({
    ...(year && { year }),
    ...(userId && { userId }),
  })}`;
};

export const useSellerMonthlyAccountedHook = (year?: number, userId?: string) => {
  const { sellerRole } = useAuth();

  useRecoilQuery(
    sellerMonthlyAccountedStatusAtom,
    sellerMonthlyAccountedDataAtom,
    sellerMonthlyAccountedUrl(sellerRole(), year, userId),
    fetcher,
  );
};

// ── 세부내역 (account/detail) URL 빌더 ──

/** bugoBrand 필터 파라미터 (상호 배타적) */
export interface BrandFilterParams {
  bugoBrandIds?: string[];
  excludeBugoBrandIds?: string[];
}

export const sellerAccountDetailExportUrl = (
  sellerRole: string,
  year: number,
  month: number,
  type: AccountDetailType,
  brandFilter?: BrandFilterParams,
  userId?: string,
) => {
  return `/${sellerRole}/shop-order/account/detail/export?${queryString({
    year,
    month,
    type,
    ...(brandFilter?.bugoBrandIds &&
      brandFilter.bugoBrandIds.length > 0 && {
        bugoBrandIds: brandFilter.bugoBrandIds.join(','),
      }),
    ...(brandFilter?.excludeBugoBrandIds &&
      brandFilter.excludeBugoBrandIds.length > 0 && {
        excludeBugoBrandIds: brandFilter.excludeBugoBrandIds.join(','),
      }),
    ...(userId && { userId }),
  })}`;
};

export const sellerAccountDetailUrl = (
  sellerRole: string,
  year: number,
  month: number,
  type: AccountDetailType,
  brandFilter?: BrandFilterParams,
  page?: number,
  limit?: number,
  userId?: string,
) => {
  return `/${sellerRole}/shop-order/account/detail?${queryString({
    year,
    month,
    type,
    ...(brandFilter?.bugoBrandIds &&
      brandFilter.bugoBrandIds.length > 0 && {
        bugoBrandIds: brandFilter.bugoBrandIds.join(','),
      }),
    ...(brandFilter?.excludeBugoBrandIds &&
      brandFilter.excludeBugoBrandIds.length > 0 && {
        excludeBugoBrandIds: brandFilter.excludeBugoBrandIds.join(','),
      }),
    ...(page && { page }),
    ...(limit && { limit }),
    ...(userId && { userId }),
  })}`;
};
